import axios from 'axios'
import {
  HIDE_INTERVENTION_BY_ID,
  SAVE_DELETED_INTERVENTION_ID,
  SET_DRAWER_STATE,
  SET_LOCALE,
  SET_UNDO_TYPE,
  SHOW_INTERVENTION_BY_ID,
  UPDATED_INTERVENTION
} from './mutation-types'
import { undoTypes } from './modules/undo'
import { SET_UNDO_STATE_ASYNC } from './action-types'

export const setLanguageFromDescription = ({commit, getters}, description) => {
  const locale = getters.getLanguageFromDescription(description)
  commit(SET_LOCALE, {locale: locale})
}

export const DELETE_INTERVENTION_BY_ID = (context, interventionId) => {
  const actionData = { action: DELETE_INTERVENTION_BY_ID, data: interventionId }
  handleInterventionState(context, interventionId, true, actionData)
}

export const UNDO_DELETE_INTERVENTION_BY_ID = (context, interventionId) => {
  const actionData = { action: UNDO_DELETE_INTERVENTION_BY_ID, data: interventionId }
  handleInterventionState(context, interventionId, false, actionData)
}

const handleInterventionState = ({commit, state, dispatch}, interventionId, toBeDeleted, actionData) => {
  commit(SAVE_DELETED_INTERVENTION_ID, interventionId)
  axios({
    url: `${state.config.baseUrl}:${state.config.port}/core/intervention/${interventionId}/delete/${toBeDeleted}`,
    method: 'delete',
    headers: {
      'Authorization': state.profile.loginToken
    },
    actionData
  })
    .then((res) => {
      if (toBeDeleted) {
        dispatch(SET_UNDO_STATE_ASYNC, true)
        commit(SET_UNDO_TYPE, undoTypes.INTERVENTION_DELETION)
        commit(HIDE_INTERVENTION_BY_ID, interventionId)
      } else {
        dispatch(SET_UNDO_STATE_ASYNC, false)
        commit(SHOW_INTERVENTION_BY_ID, interventionId)
      }
    })
    .catch((err) => {
      if (toBeDeleted) {
        console.log('Failed to delete intervention')
        console.error(err)
      } else {
        console.log('Failed to undo deletion of intervention')
        console.error(err)
      }
    })
}

export const closeIntervention = (context, data) => {
  let {id, closureReasonId, closureDate, closureReasonSummary} = data
  const actionData = { action: 'closeIntervention', data }
  axios({
    url: `${context.state.config.baseUrl}:${context.state.config.port}/core/intervention/${id}/close`,
    method: 'put',
    data: {
      closureReasonId, closureDate, closureReasonSummary
    },
    headers: {
      'Authorization': context.state.profile.loginToken
    },
    actionData
  }).then(res => {
    context.commit(SET_DRAWER_STATE, false)
    context.commit(UPDATED_INTERVENTION, res.data)
  }).catch((err) => {
    console.log('error', err)
  })
}



// WEBPACK FOOTER //
// ./src/store/actions.js